import { ArrowRight, Briefcase, GraduationCap, Music } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Layout";

const PROFILES = [
  {
    key: "aluno",
    label: "Aluno",
    description: "Portal do aluno e do responsável: aulas, comunicados e materiais.",
    icon: GraduationCap,
    testId: "access-option-aluno",
  },
  {
    key: "professor",
    label: "Professor",
    description: "Sua visão de trabalho: aulas da semana, agenda e solicitações.",
    icon: Music,
    testId: "access-option-professor",
  },
  {
    key: "administrativo",
    label: "Administrativo",
    description: "Gestão do instituto: matrículas, financeiro, agenda e equipe.",
    icon: Briefcase,
    testId: "access-option-administrativo",
  },
];

export default function Access() {
  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid="access-page">
      <div className="relative flex flex-col justify-between bg-zinc-950 p-8 sm:p-12">
        <Logo dark />
        <div className="py-10 lg:py-0">
          <h1 className="font-heading text-3xl font-extrabold leading-tight text-white sm:text-4xl">
            Instituto Musical Jacaré
          </h1>
          <p className="mt-3 max-w-md text-base text-zinc-400">
            20 anos formando músicos em Cabreúva — SP.
          </p>
          <div className="mt-6 h-1 w-24 bg-primary" />
        </div>
        <p className="text-xs text-zinc-500">Rua Luiz Nunes, 36 — Bairro Jacaré, Cabreúva/SP</p>
      </div>

      <div className="flex items-center justify-center bg-white p-6 sm:p-12">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <Logo />
          </div>
          <h2 className="font-heading text-3xl font-bold" data-testid="access-title">Como você quer acessar?</h2>
          <p className="mt-1 text-sm text-muted-foreground">Escolha seu perfil para continuar.</p>

          <div className="mt-8 space-y-3">
            {PROFILES.map((p) => (
              <Link
                key={p.key}
                to={`/login?perfil=${p.key}`}
                className="group flex items-center gap-4 border border-border bg-white p-4 transition-all hover:-translate-y-0.5 hover:border-primary hover:shadow-md"
                data-testid={p.testId}
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center bg-zinc-950 text-primary transition-colors group-hover:bg-primary group-hover:text-zinc-950">
                  <p.icon size={20} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block font-heading text-base font-bold">{p.label}</span>
                  <span className="block text-xs text-muted-foreground">{p.description}</span>
                </span>
                <ArrowRight size={16} className="shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-primary" />
              </Link>
            ))}
          </div>

          <p className="mt-6 text-[11px] leading-relaxed text-muted-foreground" data-testid="access-note">
            A escolha do perfil é apenas para navegação. As permissões são validadas pelo sistema após o login.
          </p>
          <p className="mt-4 text-center text-xs">
            <Link to="/" className="text-muted-foreground underline-offset-2 transition-colors hover:text-foreground hover:underline" data-testid="access-back-site">
              ← Voltar ao site
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
